export enum CxWizardMode {
	VIEW = 'view',
	VIEW_LAST_PAGE_ONLY = 'view_last_page_only',
	EDIT = 'edit'
}